import type * as core from '../../../../../../core'

export const PACKAGE = {
  contents: [
    'package:data.universal.orgStructure.withoutDivisions',
    'resource:data.dimensions.personnel.snapshots.checkIn',
    'resource:data.dimensions.personnel.snapshots.checkIn.attributes.mood',
    'resource:data.dimensions.personnel.snapshots.checkIn.attributes.prompt',
    'resource:data.dimensions.personnel.snapshots.checkIn.attributes.response',
    'resource:data.dimensions.personnel.snapshots.checkIn.attributes.utcOffset',
  ],
  description: 'TODO',
  name: 'Org Structure - Check-Ins',
} as const satisfies core.quiver.Package
